import { render, staticRenderFns } from "./RolesSection.vue?vue&type=template&id=60cd95d6&scoped=true&"
import script from "./RolesSection.vue?vue&type=script&lang=js&"
export * from "./RolesSection.vue?vue&type=script&lang=js&"
import style0 from "./RolesSection.vue?vue&type=style&index=0&id=60cd95d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cd95d6",
  null
  
)

export default component.exports